export default __webpack_public_path__ + "static/media/kate_fawkes.e1cf773d.png";